import SequenceInput from './SequenceInput';
export default SequenceInput;
